/*
 * CONFIDENTIAL AND PROPRIETARY
 *
 * Copyright (c) 2003 - 2021 Levels Beyond
 * Copyright (c) 2021 - 2023 Signiant (by acquisition)
 * Portions Copyright (c) 2023 - 2026 Quickplay Media
 *
 * ALL RIGHTS RESERVED
 *
 * This software is licensed to Quickplay Media under a formal
 * license agreement. Unauthorized use, reproduction, or
 * distribution is strictly prohibited.
 */

/**
 * Filename: queue-limiter-list-modal-controller.js
 *
 * Created by psnyder on 2/27/17.
 */
'use strict';

angular.module('prism-ui.queues').controller('QueueLimiterListController',
    function (
        $q,
        $scope,
        $uibModalInstance,
        queueId,
        uiGridConstants,
        ModalService,
        NotificationService,
        PermissionsService,
        QueuesViewService
    ) {
        var self = this;

        self.queueMaxActive = null;
        self.selectedLimiterObject = {};

        self.loadingIndicator = {
            backdrop: true,
            show: false,
            title: 'Working',
            message: 'Please wait...'
        };

        self.queuePermissions = {
            sysOp: false,
            write: false,
        };

        self.gridColumns = [
            {
                field: 'partner.name',
                displayName: 'Partner',
                suppressRemoveSort: true,
                enableColumnResizing: true,
                sort: {
                    direction: uiGridConstants.ASC,
                    priority: 0
                },
                sortingAlgorithm: function (a, b) {
                    if (a === undefined) {
                        a = '';
                    } else {
                        a = a.toLowerCase();
                    }
                    if (b === undefined) {
                        b = '';
                    } else {
                        b = b.toLowerCase();
                    }
                    return a.localeCompare(b);
                },
                cellTemplate: 'components/visual/grid/base-tooltip-template.html'
            },
            {
                field: 'categoryType.name',
                displayName: 'Category Type',
                enableSorting: false,
                suppressRemoveSort: true,
                enableColumnResizing: false,
                cellTemplate: 'components/visual/grid/base-tooltip-template.html'
            },
            {
                field: 'maxActive',
                displayName: 'Max Active',
                enableSorting: false,
                suppressRemoveSort: true,
                enableColumnResizing: false,
                cellTemplate: 'components/visual/grid/base-tooltip-template.html'
            }
        ];

        self.gridOptions = {
            rowSelection: true,
            multiSelect: false,
            enableColumnMenus: false,
            enableFullRowSelection: true,
            enableRowHeaderSelection: false,
            rowHeight: 30,
            minRowsToShow: 5,
            columnDefs: self.gridColumns,
            rowTemplate: '<div ng-dblclick="grid.appScope.queueLimiterController.rowDoubleClicked(row)" ' +
            ' ng-repeat="(colRenderIndex, col) in colContainer.renderedColumns track by col.uid" ' +
            ' class="ui-grid-cell" ui-grid-cell></div>',
            onRegisterApi: function (gridApi) {
                self.gridApi = gridApi;
                gridApi.selection.on.rowSelectionChanged($scope, self.gridRowSelectionChangedHandler);
            }
        };

        self.gridRowSelectionChangedHandler = function (row) {
            if (row.isSelected) {
                self.selectedLimiterObject = angular.copy(row.entity);
            } else {
                self.selectedLimiterObject = {};
            }
        };

        self.rowDoubleClicked = function (row) {
            ModalService.showQueueLimiterEditModal(row.entity.id, self.queueObject.maxActive, self.saveQueueLimiter);
        };

        self.addQueueLimiter = function () {
            ModalService.showQueueLimiterEditModal(-1, self.queueObject.maxActive, self.saveQueueLimiter);
        };

        self.saveQueueLimiter = function (limiterObj) {
            self.loadingIndicator.show = true;
            QueuesViewService.saveQueueLimiter(limiterObj).then(function (data) {
                self.selectedLimiterObject = {};
                self.setQueuesListModalData();
                self.loadingIndicator.show = false;
            });
        };

        self.setQueuesListModalData = function () {
            self.loadingIndicator.show = true;
            $q.all([
                PermissionsService.isSystemOperator().then(function (isSystemOperator) {
                    self.queuePermissions.sysOp = isSystemOperator;
                    self.canClearQueue = isSystemOperator;
                    if (PermissionsService.isAdmin()) {
                        self.queuePermissions.write = true;
                    }
                }),

                //
                // 2026-05-29: Robert does not want any ordinary
                //     users editing queue limiters. If that ever
                //     changes, uncomment the promise block below.
                //

                // QueuesViewService.getQueueViewPermissions().then(function (permissions) {
                //     self.queuePermissions.write = permissions.write;
                // }),

                QueuesViewService.getQueuesListData(queueId).then(function (data) {
                    self.gridOptions.data = data.queueLimiters;
                    self.queueObject = data.queueData;
                    self.originalQueueMaxActive = self.queueObject.maxActive;

                    QueuesViewService.queueLimiters = data.queueLimiters;
                })
            ]).then(function() {
                self.loadingIndicator.show = false;
            });
        };

        self.disableLimiterDeleteButton = function () {
            return angular.equals(self.selectedLimiterObject, {}) || self.queuePermissions.write === false;
        };

        self.deleteQueueLimiter = function () {
            self.loadingIndicator.show = true;
            QueuesViewService.deleteQueueLimiter(self.selectedLimiterObject).then(function (data) {
                self.selectedLimiterObject = {};
                self.setQueuesListModalData();
                self.loadingIndicator.show = false;
            });
        };

        self.deleteMessage = 'Are you sure you want to delete ';
        self.openConfirmModal = function (messageText, title, handler) {
            messageText += self.selectedLimiterObject.name + '?';
            title += ' ' + self.selectedLimiterObject.name + '?';
            ModalService.showMessageModal({
                messageText: messageText,
                pullCancelLeft: true,
                title: title,
                windowClass: 'confirm-modal-sm',
                showOK: true
            }, handler);
        };

        self.disableListComponents = function () {
            return (
                self.modalForm.$dirty ||
                self.queuePermissions.write === false
            );
        };

        self.disableOkButton = function () {
            return (
                self.modalForm.$pristine ||
                self.queueObject.maxActive > 999 ||
                self.queuePermissions.write === false
            );
        };

        self.disableLimiterEdit = function () {
            return self.queuePermissions.write === false;
        };

        self.onOk = function () {
            $uibModalInstance.close(self.queueObject);
            QueuesViewService.selectedQueueId = null;
            QueuesViewService.queueLimiters = [];
        };

        self.cancel = function () {
            self.queueObject.maxActive = self.originalQueueMaxActive;
            self.modalForm.$setPristine();
        };

        self.clearQueue = () => {
            ModalService.showMessageModal({
                messageText: 'Are you sure you want to clear this queue?',
                pullCancelLeft: true,
                title: 'Clear Queue',
                windowClass: 'confirm-modal-sm',
                showOK: true
            }, () => {
                QueuesViewService.clearQueue(queueId).then((clearedQueue) => {
                    NotificationService.createSuccessNotification(`Successfully cleared queue`);
                }).catch((error) => {
                    NotificationService.createFailureNotification(`Could not clear queue`);
                });
            });
        };


        self.xClicked = function () {
            $uibModalInstance.dismiss('cancel');
        };

        self.setQueuesListModalData();

    });
